import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'core-ui-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LoadingOverlayComponent {
    @Input() block = true;
    @Input() transparent = false;

    @Input() text: string | null = null;
    @Input() loaderSizePx = 80;
    @Input() backdropOpacity = 0.65;

    @HostBinding('class.core-ui-loading-overlay--blocking')
    get hostBlocking(): boolean {
        return this.block;
    }

    @HostBinding('class.core-ui-loading-overlay--transparent')
    get hostTransparent(): boolean {
        return this.transparent;
    }
}